var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMathematicsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00390625,
    width: 48.3602,
    height: 48.3602,
    rx: 24.1801,
    fill: "#90409D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3757 16.5781H18.3757V12.5781H16.3757V16.5781H12.3757V18.5781H16.3757V22.5781H18.3757V18.5781H22.3757V16.5781ZM12.3757 27.5781H22.3757V29.5781H12.3757V27.5781ZM12.3757 32.5781H22.3757V34.5781H12.3757V32.5781ZM26.3757 16.5781H36.3757V18.5781H26.3757V16.5781ZM32.7857 30.5781L36.3757 26.9881L34.9657 25.5781L31.3757 29.1681L27.7857 25.5781L26.3757 26.9881L29.9657 30.5781L26.3757 34.1681L27.7857 35.5781L31.3757 31.9881L34.9657 35.5781L36.3757 34.1681L32.7857 30.5781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathematicsIcon);
export default __webpack_public_path__ + "static/media/MathematicsIcon.1d526be712a08df79c1aa589f098397d.svg";
export { ForwardRef as ReactComponent };